



import React, { useEffect, useRef, useState } from "react";
import ApiConfig from "../../../api/ApiConfig";
import useDelayedNavigate from "../useDelayedNavigate";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

const AssessmentStreamStatus = ({ payload, onComplete }) => {
  const [logs, setLogs] = useState([]);
  const [current, setCurrent] = useState("");
  const [done, setDone] = useState(false);
  const lastMessageRef = useRef("");

  const navigate = useNavigate();

  useEffect(() => {
   let isCancelled = false;
  let hasRedirected = false;
let timeOut = null
  const redirect = () => {
    if (hasRedirected) return;
    hasRedirected = true;

     timeOut = setTimeout(() => {
      navigate("/Assessment", {
        state: { value: 3 },
      });
    }, 5000);
    timeOut();
  };



    const startStream = async () => {
      try {
        const response = await fetch(
          ApiConfig.GENERATE_BULK_ASSESSMENT_QUESTION_FROM_AI,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.body) {
          throw new Error("Streaming not supported");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (!isCancelled) {
          const { value, done } = await reader.read();
        //   if (done) break;
          // Stream ended normally
        if (done) {
            console.log('1111111111111111111')
          redirect();
          break;
        }

          buffer += decoder.decode(value, { stream: true });

          // Split SSE events
          const events = buffer.split("\n\n");
          buffer = events.pop();

          events.forEach((event) => {
            if (!event.startsWith("data:")) return;

            const json = event.replace("data:", "").trim();
            const data = JSON.parse(json);


              /** ---------------- ERROR FROM BACKEND ---------------- */
        if (data.error) {
  setLogs((prev) => [
    ...prev,
    { text: data.error, type: "error" }
  ]);
//   redirect();
  return;
}

            if (data.message) {
            //   setCurrent(data.message);
              

            //   if (
            //     data.message.toLowerCase().includes("assessment created") ||
            //     data.message.toLowerCase().includes("completed")
            //   ) {
            //     setLogs((prev) => [...prev, data.message]);
            //     setCurrent("");
            //   }

            setCurrent(data.message);

// persist every new message once
// if (lastMessageRef.current !== data.message) {
//   setLogs((prev) => [...prev, data.message]);
//   lastMessageRef.current = data.message;
// }

if (lastMessageRef.current !== data.message) {
  setLogs((prev) => [
    ...prev,
    { text: data.message, type: "info" }
  ]);
  lastMessageRef.current = data.message;
}




              if (
                data.message
                  .toLowerCase()
                  .includes("bulk assessment generation completed")
              ) {
                setDone(true);
                onComplete?.();
          
               console.log('222222222222222')
            redirect();
            }
            }
          });
        }
      } catch (err) {
        console.error("Stream error:", err);
         //  Any error → redirect
          console.log('33333333333')
      redirect();
      } finally {
         //  Safety net (network aborts, unexpected exits)
             console.log('4444444444444')
      redirect();
      }
    };

    startStream();

    return () => {
      isCancelled = true;
      clearTimeout(timeOut);
    };
  }, [payload, onComplete]);

  return (
//     <div style={styles.box}>
//       {/* {logs.map((log, i) => (
//         <div key={i} style={styles.log}>
//           {log}
//         </div>
//       ))} */}

//       {logs.map((log, i) => (
//   <div
//     key={i}
//     style={{
//       ...styles.log,
//       color: log.type === "error" ? "#d32f2f" : "#333",
//       fontWeight: log.type === "error" ? "600" : "400",
//     }}
//   >
//     {log.text}
//   </div>
// ))}

//       {!done && (
//         // <div style={styles.thinking}>
//         <div
//   style={{
//     ...styles.thinking,
//     color: current?.toLowerCase().includes("error") ? "#d32f2f" : "#333",
//   }}
// >
//           {current}  
//           {/* <span style={styles.cursor}>▌</span> */}
//           <span>
//           {" "}... {"    "}  Please wait <Spinner animation="grow" size="sm" />
//           </span>
//         </div>
//       )}

//       {done && (
//         <div style={styles.success}>
//           ✅ Your bulk assessment has been created successfully!
//         </div>
//       )}
//     </div>

 <div style={styles.box}>
      {logs?.filter((log) => log.text !== current)?.map((log, i) => {
        // 🔴 ERROR MESSAGE – RED & BOLD
        if (log.type === "error") {
          return (
            <div key={i} style={styles.errorLog}>
              {log.text}
            </div>
          );
        }

        // 🔵 ASSESSMENT CREATED – BLUE
        if (log.text.toLowerCase().includes("assessment created")) {
          return (
            <div key={i} style={styles.successLog}>
              {log.text}
            </div>
          );
        }

        // ⚪ OTHER HISTORY MESSAGES – GREY
        return (
          <div key={i} style={styles.infoLog}>
            {log.text}
          </div>
        );
      })}

      {/* 🟣 CURRENT GENERATING MESSAGE – PURPLE & BLINKING */}
      {!done && current && (
        <div style={styles.currentBlinking}>
          {current}
          <span>
            {" "}... Please wait <Spinner animation="grow" size="sm" />
          </span>
        </div>
      )}

      {done && (
        <div style={styles.finalSuccess}>
          ✅ Your bulk assessment has been created successfully!
        </div>
      )}
    </div>
  );
};

export default AssessmentStreamStatus;


const styles = {
  box: {
    padding: "1rem",
  },

  /* ⚪ OTHER MESSAGES */
  infoLog: {
    color: "#9ca3af",
    marginBottom: "6px",
  },

  /* 🔵 ASSESSMENT CREATED */
  successLog: {
    color: "#2563eb",
    fontWeight: "500",
    marginBottom: "6px",
  },

  /* 🔴 ERROR MESSAGE */
  errorLog: {
    color: "#dc2626",
    fontWeight: "700",
    marginBottom: "6px",
  },

  /* 🟣 CURRENT GENERATING MESSAGE */
  currentBlinking: {
    marginTop: "12px",
    color: "#7c3aed",
    fontWeight: "500",
    animation: "blink 1.2s infinite",
  },

  finalSuccess: {
    marginTop: "20px",
    color: "#22c55e",
    fontWeight: "bold",
    fontSize: "16px",
  },
};









// const styles = {
//   container: {
//     display: "flex",
//     justifyContent: "center",
//     padding: "40px",
//     fontFamily: "monospace",
//   },
//   box : {
//     padding:'1rem'
//   },
//   chatBox: {
//     width: "600px",
//     background: "#0f172a",
//     color: "#e5e7eb",
//     padding: "20px",
//     borderRadius: "10px",
//   },
//   message: {
//     marginBottom: "10px",
//     color: "#a5f3fc",
//   },
//   thinking: {
//     marginTop: "10px",
//     color: "#73276B",
//   },
//   cursor: {
//     marginLeft: "4px",
//     animation: "blink 1s steps(2, start) infinite",
//   },
//   success: {
//     marginTop: "20px",
//     color: "#22c55e",
//     fontWeight: "bold",
//     fontSize: "16px",
//   },

  
// };


